import { useMemo } from 'react'
import { toast } from 'sonner'
import { ActionDropdown } from '@shared/components/ui/action-dropdown/ActionDropdown'
import { Button } from '@shared/components/ui/button'
import { getProductPanelActions } from '@shared/lib/actions/product-actions'
import type { TableAction } from '@shared/types/data-table'

// Use a generic entity info type to avoid naming conflict with ProductInfo from panel types
type ProductEntityInfo = Record<string, unknown> & { id: string; status?: string }

const actions = getProductPanelActions({}) as unknown as TableAction<ProductEntityInfo>[]

interface ProductActionsProps {
  entityInfo: ProductEntityInfo
}

export function ProductActionsComponent({ entityInfo }: ProductActionsProps) {
  const primaryCTA = useMemo(() => {
    const status = entityInfo.status
    if (status === 'draft') return { label: 'Mark as Active' }
    if (status === 'active') return { label: 'Duplicate' }
    return null
  }, [entityInfo.status])

  return (
    <div className="flex items-center gap-2">
      {primaryCTA && (
        <Button
          variant="action"
          size="action"
          onClick={() => toast.info(`${primaryCTA.label} product`)}
        >
          {primaryCTA.label}
        </Button>
      )}
      <ActionDropdown actions={actions} item={entityInfo} variant="outline" />
    </div>
  )
}
